import { Box } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { InlineEditableTitle } from 'modules/trainings/components/content/items/shared/fields/InlineEditableTitle'
import { contentContainer } from 'modules/trainings/components/content/styles.vanilla.css'
import { ContentModule } from 'modules/trainings/lib/content/Module'

import {
  moduleContainerFullscreen,
  moduleContainerPreview,
  titleStyle,
  titleStyleFullscreen,
} from './ModuleView.vanilla.css'

type ModuleViewProps = {
  contentItem: ContentModule
  isFullscreen?: boolean
  readOnly?: boolean
  onContentChange?: () => void
}

const ModuleView = ({
  contentItem,
  readOnly = false,
  onContentChange,
  isFullscreen = false,
}: ModuleViewProps) => {
  const height = isFullscreen ? 'full' : 's400'
  const position = isFullscreen ? 'fixed' : undefined
  const containerClassName = isFullscreen ? moduleContainerFullscreen : moduleContainerPreview
  const paddingX = isFullscreen ? undefined : 's32'
  const innerClassName = isFullscreen ? contentContainer : ''
  const textStyle = isFullscreen ? titleStyleFullscreen : titleStyle

  const handleTitleChange = (value: string) => {
    contentItem.title = value
    onContentChange?.()
  }

  return (
    <Box
      width="full"
      height={height}
      alignItems="center"
      justifyContent="center"
      position={position}
      className={containerClassName}
    >
      <Box maxWidth="full" paddingX={paddingX} className={innerClassName}>
        {readOnly ? (
          <F0Text content={contentItem.title} variant="body" style={textStyle} />
        ) : (
          <InlineEditableTitle
            value={contentItem.title}
            placeholder={i18n.t('trainings.content.module_modal.label_placeholder')}
            ariaLabel={i18n.t('trainings.content.module_modal.label_title')}
            style={textStyle}
            onChange={handleTitleChange}
          />
        )}
      </Box>
    </Box>
  )
}

export { ModuleView }
